/** @format */

export const X_ADJUST = -16;
export const Y_ADJUST = 8;

export const X_TEXT_ADJUST = -5;
export const Y_TEXT_ADJUST = 20;
